import CheckoutTextil from './CheckoutTextil';

export default CheckoutTextil;